module.exports = __webpack_public_path__ + "static/media/home.b06a3fbf.svg";